// eslint-disable max-len

export const DEVELOPMENT = 'DEVELOPMENT';
export const PRODUCTION = 'PRODUCTION';
export const TESTING = 'TESTING';

/**
 * Environment names defined in cloudformation (except of DEVELOPMENT)
 */
export const DEPLOYMENT_ENV = {
  DEVELOPMENT: DEVELOPMENT.toLowerCase(),
  QA: 'qa',
  STAGING: 'staging',
  PRODUCTION: 'prod'
};

export const QUERY_PARAMS = {
  ADD_NEW_MEMBER: 'add_new_member',
  ADD_NEW_ORG: 'add_new_org',
  FILTER: 'filter',
  ORG_ID: 'organisation_id',
  WORKSPACE_ID: 'workspace_id',
  PRODUCT_ID: 'product_id',
  FROM_REDIRECT: 'from_redirect',
  FROM_HOSTED_UI: 'from_hosted_ui',
  ERROR: 'error',
  ERROR_DESCRIPTION: 'error_description',
  GO: 'go',
  SRC: 'src',
  PROVIDER: 'provider',
  CODE: 'code',
  STATE: 'state',
  DATASOURCE_ID: 'datasource_id',
  ORG_NAME: 'organisation_name',
  TYPE: 'type',
  CONNECTED_ORGS: 'connected_orgs',
  STATUS: 'status',
  FORECAST_TYPE: 'forecast_type',
  ONBOARDING_COMPLETE: 'onboarding_complete',
  EDIT_INVOICES_BILLS: 'edit_invoices_bills',
  ONBOARDING_FORECAST_ID: 'onboarding_forecast_id',
  SAGE_50_ERROR: 'sage-50-error',
  INTEGRATION: 'integration',
  BUSINESS_ID: 'bid',
  DASH_ID: 'dash-id'
};

export const FILTER_VALUES = {
  URGENT: 'urgent',
  RECENT: 'recent',
  PINNED: 'pinned'
};

export const ROUTE_PARAMS = {
  INSIGHTS_SCHEDULE_ID: 'insightsScheduleId',
  ONBOARDING_STEP: 'onboardingStep',
  ONBOARDING_CATEGORY: 'onboardingCategory',
  ACCOUNT_ID: 'accountId',
  ACTION_ID: 'actionId',
  ANALYSIS_ID: 'analysisId',
  ASSUMPTION_ID: 'assumptionId',
  ASSUMPTION_TYPE: 'assumptionTypeId',
  BEAT_ID: 'beatId',
  BILL_OR_INVOICE_ID: 'billOrInvoiceId',
  CATEGORY_TYPE: 'categoryType',
  CODE: 'code',
  // CONSOLIDATION_ID: 'consolidationId',
  CUSTOMER_ID: 'customerId',
  DATASOURCE_ID: 'dataSourceId',
  DRIVER_ID: 'driverId',
  DRIVER_NODE_ID: 'driverNodeId',
  ENTITY_ID: 'entityId',
  ENTITY_TYPE: 'entityType',
  FINANCIAL_DETAIL_KIND: 'financialDetailKind',
  FORECAST_ID: 'forecastId',
  FORECAST_KIND: 'forecastKind',
  INTEGRATION_JOB_ID: 'integrationJobId',
  INTEGRATION_LEVEL: 'integrationLevel',
  INTEGRATION_NAME: 'integrationName',
  MEMBER_ID: 'memberId',
  ORGANISATION_ID: 'organisationId',
  PAYMENT_TYPE: 'paymentType',
  PAYMENT_TYPE_ID: 'paymentTypeId',
  PRODUCT_ID: 'productId',
  PRODUCT_MODULE: 'productModule',
  PRODUCT_SETUP_ID: 'productSetupId',
  PRODUCT_SLUG: 'productSlug',
  ROLE_ID: 'roleId',
  USER_ID: 'userId',
  USER: 'user',
  WORKSPACE_ID: 'workspaceId',
  SNAPSHOT_ID: 'snapshotId',
  CONTACT_ID: 'contactId',
  REPORT_ID: 'reportId',
  TEMPLATE_ID: 'templateId',
  ROW_FORMULA_ID: 'rowFormulaId',
  SCHEDULE_REPORT_ID: 'scheduleReportId',
  DISPATCHED_REPORT_ID: 'dispatchedReportId',
  EXPORTED_REPORT_ID: 'exportedReportId',
  TAB_ID: 'tabId',
  IMAGE_ID: 'imageId',
  GROUP_ID: 'groupId',
  STEP_ID: 'stepId',
  DASHBOARD_ID: 'dashboardId',
  BUSINESS_ID: 'businessId',
  EXCEL_ID: 'fileId'
};

export const PRODUCT_ROUTES = {
  PREDICT: '/predict',
  FLOW: '/flow'
};

export const ROUTES = {
  PROVISION: '/provision',
  ADVISOR: '/advisor',
  REMOVE_ALL_SCHEDULES: '/remove_all_schedules',
  SCHEDULES: '/schedules',
  BUSINESS_INSIGHT: '/business-insight',
  PREFERENCES: '/preferences',
  BUDGET: '/budget',
  SCENARIO: '/scenario',
  SCENARIOS: '/scenarios',
  SCENARIO_WITH_INVOICES: '/scenario-with-invoices',
  ONBOARDING_STEP: `/:${ROUTE_PARAMS.ONBOARDING_STEP}`,
  ONBOARDING_CATEGORY: `/:${ROUTE_PARAMS.ONBOARDING_CATEGORY}`,
  INITIAL_SYNC: '/initial-sync',
  ONBOARDING_INITIAL: '/initial',
  ACCOUNTS: '/accounts',
  SAGE_ORGS: '/sage-organisations',
  CATEGORY_TYPE: `/:${ROUTE_PARAMS.CATEGORY_TYPE}`,
  CONSOLIDATIONS_ROUTE: `/consolidations`,
  CONSOLIDATION_BY_ID: `/:${ROUTE_PARAMS.ORGANISATION_ID}`, // why organisationId and not consolidationId? For compatibility - lots of code already looks for organisationId in the route and we don't want to rewrite it all.
  CONSOLIDATION_TAB: `/:${ROUTE_PARAMS.TAB_ID}?`,
  CREATE_CONSOLIDATION: `/create-consolidation`,
  COST_OF_SALES: `/cost-of-sales`,
  EXPENSES: `/expenses`,
  EXPORT: `/export`,
  FEDERATED_SIGN_IN_REDIRECT: '/federated-sign-in-redirect',
  SAGE_ID_SIGN_IN_TRIGGER: '/sso/sageid',
  SAGE_50_TRIGGER: `/sso/sageid/org-service/:${ROUTE_PARAMS.BUSINESS_ID}`,
  SFA_TRIGGER: '/sso/sageid/org-service/',
  FEDERATED_SIGN_IN_TRIGGER: '/sso',
  SSO_EMBED_TRIGGER: '/sso-embed',
  SSO_EMBED_USER: '/sso-embed-user',
  FINANCIALS: `/financials`,
  FINANCIAL_DETAIL_KIND: `/:${ROUTE_PARAMS.FINANCIAL_DETAIL_KIND}`,
  FLOW: PRODUCT_ROUTES.FLOW,
  FORECAST_BY_ID: `/:${ROUTE_PARAMS.FORECAST_ID}`,
  FORECAST_KIND: `/:${ROUTE_PARAMS.FORECAST_KIND}`,
  FORECASTS: '/forecasts',
  CONTACTS: '/contacts',
  HOME: '/home',
  INTEGRATION_META_ROUTE: `/:${ROUTE_PARAMS.INTEGRATION_NAME}/:${ROUTE_PARAMS.INTEGRATION_JOB_ID}`,
  INTEGRATIONS_ONBOARDING_ROUTE: '/onboarding/integrations',
  INTEGRATIONS_PUSHBAR_ROUTE: '/pushbar/integrations',
  START: '/start',
  INTEGRATIONS_ROUTE: `/integrations`,
  XERO_ADDITIONAL: '/xero-additional',
  ADDITIONAL_INFO: '/additional-info',
  INTRODUCTION: '/introduction',
  INVITE: '/invite',
  INVOICES: '/invoices-and-bills',
  BILLS_OR_INVOICE_BY_ID: `/:${ROUTE_PARAMS.BILL_OR_INVOICE_ID}`,
  IMPORT: '/import',
  IMPORT_REDIRECT: '/import/redirect',
  LOGIN: '/login',
  MEMBERS_BY_ID_ROUTE: `/:${ROUTE_PARAMS.MEMBER_ID}`,
  MEMBERS_ROUTE: '/members',
  NON_FINANCIAL_DRIVERS: '/drivers',
  NON_FINANCIAL_DRIVERS_BY_ID: `/:${ROUTE_PARAMS.DRIVER_ID}?`,
  ONBOARDING_ROUTE: '/onboarding',
  ORGANISATION_BY_ID_ROUTE: `/:${ROUTE_PARAMS.ORGANISATION_ID}`,
  ORGANISATION_BY_ID: `organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/`,
  ORGANISATIONS_ROUTE: '/organisations',
  OVERVIEW: '/overview',
  PAYMENT_DETAILS: '/payment-details',
  PEOPLE: `/people`,
  PREDICT: PRODUCT_ROUTES.PREDICT,
  PRODUCT_ID: `/:${ROUTE_PARAMS.PRODUCT_ID}`,
  PRODUCT_MODULE: `/:${ROUTE_PARAMS.PRODUCT_MODULE}`,
  PRODUCT_SLUG_ROUTE: `/:${ROUTE_PARAMS.PRODUCT_SLUG}`,
  PRODUCT_SLUG: `:${ROUTE_PARAMS.PRODUCT_SLUG}`,
  PULSE: '/pulse',
  REDIRECT_NEW_ORG: '/new-org',
  REDIRECT_ONBOARDING: '/onboarding',
  REDIRECT_SETTINGS: '/settings',
  REDIRECT_SETTINGS_ORGS: '/settings-orgs',
  REDIRECT: 'go/',
  REGISTER: '/register',
  ROLE_BY_ID_ROUTE: `/:${ROUTE_PARAMS.ROLE_ID}`,
  REPORTING_BY_ID: `/:${ROUTE_PARAMS.REPORT_ID}`,
  ROLES_ROUTE: 'roles',
  ROOT_ROUTE: '/',
  SALES: '/sales',
  SETTINGS_OVERVIEW_PRODUCT_ROUTE: `/products/:${ROUTE_PARAMS.PRODUCT_ID}`,
  SFA: '/sfa',
  SNAPSHOTS: '/snapshots',
  SYNCING_PROGRESS: '/syncing-progress',
  TRIAL_EXPIRED: '/trial-expired',
  PERFORMANCE: '/performance',
  PREDICTIONS: '/predictions',
  WORKSPACE_BY_ID_ROUTE: `/:${ROUTE_PARAMS.WORKSPACE_ID}`,
  WORKSPACE_BY_ID_SETTINGS_ROUTE: '/settings',
  WORKSPACE_BY_ID: `workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/`,
  WORKSPACES_ROUTE: '/workspaces',
  USERS_ROUTE: '/users',
  ACCOUNT_ROUTE: '/account',
  COSTS: '/costs',
  OTHER_P_AND_L: '/other-p-and-l',
  ASSETS: '/assets',
  LIABILITIES: '/liabilities',
  PROFIT_AND_LOSS: '/profit-and-loss',
  BALANCE_SHEET: '/balance-sheet',
  CASH_FLOW_STATEMENT: '/cash-flow-statement',
  VARIANCES: '/variances',
  CONTACT_BY_ID: `/:${ROUTE_PARAMS.CONTACT_ID}`,
  UNPAID_INVOICES: '/unpaid-invoices',
  REPORTING: '/reporting',
  REPORTS_LIST: '/reports-list',
  REPORT_SCHEDULING: '/report-scheduling',
  EXPORTED_PDFS: '/exported-pdfs',
  REPORT_TEMPLATES: '/report-templates',
  DASHBOARDS: '/dashboards',
  PERFORMANCE_DASHBOARDS: '/performance-dashboards',
  DASHBOARDS_LIST: '/dashboards-list',
  DASHBOARD_TEMPLATES: '/dashboard-templates',
  REPORTING_VIEW: `/reporting/:${ROUTE_PARAMS.REPORT_ID}/view`,
  REPORTING_EDIT: `/reporting/:${ROUTE_PARAMS.REPORT_ID}/edit`,
  REPORT_TEMPLATE_VIEW: `/reporting/template/:${ROUTE_PARAMS.TEMPLATE_ID}/view`,
  REPORT_TEMPLATE_EDIT: `/reporting/template/:${ROUTE_PARAMS.TEMPLATE_ID}/edit`,
  QUICK_COPY: '/quick-copy',
  NEW: '/new',
  VIEW: '/view',
  INTERNAL: '/internal',
  LIVE: '/live',
  MY_PROFILE: '/my-profile',
  ASSUMPTIONS: '/assumptions',
  BULK_UPDATE: '/bulk-update',
  REPORT_SCHEDULE: '/report-schedule',
  DISPATCHED: '/dispatched',
  DOCUMENT_LIBRARY: '/document-library',
  SCHEDULED_REPORTS: '/scheduled-reports',
  AWAITING_REVIEW: '/awaiting-review',
  SENT_PDFS: '/sent-pdfs',
  EXPORTED: '/exported',
  EMAIL: '/email',
  CHART_OF_ACCOUNTS: '/chart-of-accounts',
  RECATEGORISE_ACCOUNT: '/recategorise-account',
  SWITCH_RULE: '/switch-rule',
  REPORT_BRANDING: '/report-branding',
  PERFORMANCE_METRICS: '/performance-metrics',
  BUSINESS_INSIGHTS: '/business-insights',
  FORECAST_START: '/forecast-start',
  BUDGET_DATE_SELECT: '/budget-date-select',
  SCENARIO_TYPE: '/scenario-type',
  WIDGET: '/widget',
  ANALYSIS: '/analysis',
  LATEST: '/latest',
  FORECASTS_LIST: '/forecasts-list',
  PERFORMANCE_COMPARISON: '/performance-comparison'
};

export const WORKSPACES_BASE = `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}`;

export const WORKSPACES_AND_ORGANISATION_BASE = `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}`;
export const WORKSPACES_AND_CONSOLIDATION_BASE = `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/consolidations/:${ROUTE_PARAMS.ORGANISATION_ID}`;

export const API_PATHS = {
  AI_ANALYSIS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.ANALYSIS}${ROUTES.LATEST}/`,
  AI_ANALYSIS_FEEDBACK: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.ANALYSIS}/:${ROUTE_PARAMS.ANALYSIS_ID}/feedback/`,
  WORKSPACES_PROVISION: `${ROUTES.WORKSPACES_ROUTE}${ROUTES.PROVISION}/`,
  TRIGGER_ELOQUA: '/users/current/event/elq/signup/',
  USERS_CURRENT: '/users/current/',
  USERS_CURRENT_LOGIN_EVENT: '/users/current/event/login/',
  USERS_VALIDATE: '/users/validate/',
  FETCH_PREFERENCES: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/:${ROUTE_PARAMS.MEMBER_ID}/accept-invite/`,
  ACCEPT_INVITE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/:${ROUTE_PARAMS.MEMBER_ID}/accept-invite/`,
  ADD_MEMBER_ORGANISATIONS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/:${ROUTE_PARAMS.MEMBER_ID}/organisations/`,
  BEAT_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}/beats/:${ROUTE_PARAMS.BEAT_ID}/`,
  BEATS: `${WORKSPACES_AND_ORGANISATION_BASE}/beats/`,
  BILLING_META: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/meta/`,
  BRAND_COLOURS: '/brand/',
  CONSOLIDATED_FORECASTS: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/`,
  CONSOLIDATED_FORECAST_BY_ID: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/`,
  CONSOLIDATED_FORECAST_BY_ID_BULK_UPDATE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/consolidations/:${ROUTE_PARAMS.ORGANISATION_ID}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}${ROUTES.ASSUMPTIONS}${ROUTES.BULK_UPDATE}/`,
  CONSOLIDATED_FORECAST_EXPORT_GOOGLE_SHEETS: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/external-sheets/export/`,
  CONSOLIDATIONS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/consolidations`,
  CONSOLIDATION_ASSUMPTIONS: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/assumptions/`,
  CONSOLIDATION_ASSUMPTIONS_IMPACT_PREVIEW: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/assumptions/preview-impacts/`,
  CONSOLIDATION_ASSUMPTION_BY_ID: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/assumptions/:${ROUTE_PARAMS.ASSUMPTION_ID}/`,
  CONSOLIDATION_ASSUMPTIONS_LINE_DATA: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/available-line-data/formula-assumptions/?organisation_id=:${ROUTE_PARAMS.ENTITY_ID}`,
  CONSOLIDATION_BY_ID: `${WORKSPACES_AND_CONSOLIDATION_BASE}/`,
  CONSOLIDATION_COA: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/predict/chart-of-accounts/bulk-flat/`,
  CONSOLIDATION_FX_HISTORICAL_RATES: `${WORKSPACES_AND_CONSOLIDATION_BASE}/fx-data/`,
  CONSOLIDATION_FX_OVERRIDES: `${WORKSPACES_AND_CONSOLIDATION_BASE}/fx-override/`,
  CONSOLIDATION_SUB_ENTITIY_FORECASTS: `${WORKSPACES_AND_CONSOLIDATION_BASE}/sub-entity-forecasts/`,
  CONSOLIDATION_USER_ORGS: `/predict/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/`,
  CONSOLIDATED_FORECAST_REPORT: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/report/`,
  CONSOLIDATION_FORECAST_REPORT_BY_ID: `${WORKSPACES_AND_CONSOLIDATION_BASE}/consolidated-forecasts/:${ROUTE_PARAMS.FORECAST_ID}/report/`,
  CHANGE_ORGANISATION_OWNERSHIP: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/change-organisation-ownership/`,
  CUSTOMERS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/customers/`,
  DELETE_MEMBER_ORGANISATIONS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/:${ROUTE_PARAMS.MEMBER_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/`,
  DUPLICATE_ROLE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/roles/?copy=:${ROUTE_PARAMS.ROLE_ID}`,
  ESTIMATES: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/estimates/:${ROUTE_PARAMS.PRODUCT_SLUG}/:${ROUTE_PARAMS.INTEGRATION_LEVEL}/`,
  FX_HISTORICAL_RATES: `/currencies/historical-fx/`,
  FX_SUPPORTED_CURRENCIES: `/currencies/supported/`,
  SIGNUP_ESTIMATES: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/estimates/signup/`,
  INTEGRATIONS: '/store/integrations/',
  OAUTH2_CONNECT: '/integrations/oauth2/connections/',
  OAUTH2_SYNC_NOW: `/integrations/oauth2/connections/:${ROUTE_PARAMS.DATASOURCE_ID}/syncnow`,
  MEMBER_ID: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/:${ROUTE_PARAMS.MEMBER_ID}/`,
  RESEND_INVITE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/:${ROUTE_PARAMS.MEMBER_ID}/resend-invite`,
  MEMBERS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/members/`,
  MEMBERS_BY_ORGANISATION: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/members/`,
  MEMBERS_BY_ORGANISATION_CONSOLIDATION: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/consolidations/:${ROUTE_PARAMS.ORGANISATION_ID}/members/`,
  USERS_MFA: `/users/:${ROUTE_PARAMS.USER_ID}/mfa/`,
  ORGANISATION_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}/`,
  ORGANISATIONS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/`,
  RESOURCE_PERMISSIONS_BY_ENTITY: `${WORKSPACES_AND_ORGANISATION_BASE}/predict/access-control/by-entity/:${ROUTE_PARAMS.ENTITY_TYPE}/:${ROUTE_PARAMS.ENTITY_ID}/`,
  RESOURCE_PERMISSIONS_BY_ENTITY_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/access-control/by-entity/:${ROUTE_PARAMS.ENTITY_TYPE}/:${ROUTE_PARAMS.ENTITY_ID}/`,
  PAYMENT_INTENTS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/payment-intents/`,
  PREFERENCE_BY_PRODUCT_ID: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/preferences/:${ROUTE_PARAMS.PRODUCT_ID}`,
  PRODUCT_SETUP_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}/products/:${ROUTE_PARAMS.PRODUCT_SETUP_ID}/`,
  PRODUCT_SETUP: `${WORKSPACES_AND_ORGANISATION_BASE}/products/`,
  REMOVE_OWN_ORGANISATION_ACCESS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/revoke-own-access/`,
  ROLE_BY_ID: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/roles/:${ROUTE_PARAMS.ROLE_ID}/`,
  ROLES_META: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/roles/?meta=true`,
  ROLES: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/roles/`,
  SETUP_INTENTS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/setup-intents/`,
  SNAPSHOT: `${WORKSPACES_AND_ORGANISATION_BASE}/snapshot/`,
  SUBSCRIPTIONS_STORE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/subscriptions/store/`,
  SUBSCRIPTIONS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/subscriptions/`,
  SUBSCRIPTIONS_ACTIVATE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/subscriptions/activate/`,
  USER_PROPERTIES: `/users/properties/`,
  USER_DETAILS: `/users/:${ROUTE_PARAMS.USER_ID}/`,
  WORKSPACE_BY_ID: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/`,
  WORKSPACE_PERMISSIONS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/permission-sets/?filter=workspace_settings`,
  WORKSPACES: '/workspaces/',
  DATASOURCE_POLL_DATA: '/workspaces/datasources/update-poll/',
  ALL_WORKSPACES_DATA: '/workspaces/listing-page/',
  ADD_ORGANISATION_ESTIMATES: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/billing/estimates/add_organisation/`,
  CURRENT_FINANCIAL_CONFIG: `${WORKSPACES_AND_ORGANISATION_BASE}/predict/financial-config/`,
  CURRENT_FINANCIAL_CONFIG_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/financial-config/`,
  AVAILABLE_LINE_DATA_FORMULAS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/predict/forecasts/:${ROUTE_PARAMS.FORECAST_ID}/available-line-data/formulas/`,
  AVAILABLE_LINE_DATA_ROW_FORMULA_V2: `${WORKSPACES_AND_ORGANISATION_BASE}/predict/available-line-data/row-formulas/v2/`,
  AVAILABLE_LINE_DATA_ROW_FORMULA_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/available-line-data/row-formulas/`,
  CHART_OF_ACCOUNTS: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}/predict/forecasts/:${ROUTE_PARAMS.FORECAST_ID}${ROUTES.CHART_OF_ACCOUNTS}/`,
  CHART_OF_ACCOUNTS_FULL_STRUCTURE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}${ROUTES.PREDICT}${ROUTES.CHART_OF_ACCOUNTS}/full-structure/`,
  COA_CREATE_GROUP: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}${ROUTES.PREDICT}${ROUTES.CHART_OF_ACCOUNTS}/groups/`,
  COA_UPDATE_GROUP: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}${ROUTES.PREDICT}${ROUTES.CHART_OF_ACCOUNTS}/groups/:${ROUTE_PARAMS.GROUP_ID}/`,
  RECATEGORIZE_ACCOUNT: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}${ROUTES.PREDICT}${ROUTES.CHART_OF_ACCOUNTS}${ROUTES.RECATEGORISE_ACCOUNT}/`,
  SWITCH_RULE: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/organisations/:${ROUTE_PARAMS.ORGANISATION_ID}${ROUTES.PREDICT}${ROUTES.CHART_OF_ACCOUNTS}${ROUTES.ACCOUNTS}/:${ROUTE_PARAMS.ACCOUNT_ID}${ROUTES.SWITCH_RULE}/`,
  EXCEL_UPLOAD_GET_PRESIGNED_URL: `${WORKSPACES_BASE}${ROUTES.PREDICT}/excel-uploads/presigned-url/`,
  EXCEL_UPLOAD_SCAN_STATUS: `${WORKSPACES_BASE}${ROUTES.PREDICT}/excel-uploads/scan-status/:${ROUTE_PARAMS.EXCEL_ID}/`,
  EXCEL_FILE_VALIDATION: `${WORKSPACES_BASE}${ROUTES.PREDICT}/excel-uploads/excel-organisation-file-validation/:${ROUTE_PARAMS.EXCEL_ID}/`,
  EXCEL_UPLOAD_ORGANISATION: `${WORKSPACES_BASE}${ROUTES.PREDICT}/excel-uploads/upload-organisation/:${ROUTE_PARAMS.EXCEL_ID}/`,
  ORGANISATION_EXCEL_FILES: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/files/`,
  ORGANISATIONS_FOR_LINKING: `/workspaces/:${ROUTE_PARAMS.WORKSPACE_ID}/holding-organisation/:${ROUTE_PARAMS.ORGANISATION_ID}/setup`,
  // Predict API paths
  PREFERENCES: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.PREFERENCES}/:${ROUTE_PARAMS.USER_ID}/`,
  FETCH_MULTIPLE_FORECAST: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}/`,
  FORECAST_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/`,
  FORECASTS_BULK_UPDATE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.ASSUMPTIONS}${ROUTES.BULK_UPDATE}/`,
  FORECAST_REPORT_BY_ID_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/report/v2/`,
  FORECAST_ASSUMPTION: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/assumptions/:${ROUTE_PARAMS.ASSUMPTION_TYPE}/`,
  FORECAST_ASSUMPTION_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/assumptions/:${ROUTE_PARAMS.ASSUMPTION_TYPE}/:${ROUTE_PARAMS.ASSUMPTION_ID}/`,
  FORECAST_BASIC_ASSUMPTION_AMOUNTS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/assumptions/:${ROUTE_PARAMS.ASSUMPTION_TYPE}/:${ROUTE_PARAMS.ASSUMPTION_ID}/amounts/`,
  FORECAST_DATA_CHECK: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/data-check/`,
  FORECAST_THIS_NUMBER_EXPLAINED: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/this-number-explained/`,
  ASSUMPTION_PAYMENT_TYPE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/assumptions/:${ROUTE_PARAMS.ASSUMPTION_ID}/payment-types/:${ROUTE_PARAMS.PAYMENT_TYPE}/`,
  ASSUMPTION_PAYMENT_TYPE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/assumptions/:${ROUTE_PARAMS.ASSUMPTION_ID}/payment-types/:${ROUTE_PARAMS.PAYMENT_TYPE}/:${ROUTE_PARAMS.PAYMENT_TYPE_ID}/`,
  SETTINGS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/settings/`,
  ACCOUNTS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/settings/accounts/`,
  UNPAID_INVOICES: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.UNPAID_INVOICES}/`,
  UNPAID_INVOICE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.UNPAID_INVOICES}${ROUTES.BILLS_OR_INVOICE_BY_ID}/`,
  UNPAID_INVOICE_BULK: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.UNPAID_INVOICES}${ROUTES.BULK_UPDATE}/`,
  VAT_DEFERRAL: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/vat-deferral/`,
  VAT_PAYMENT: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/vat-payments/`,
  ACCOUNT_GROUPS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/account-groups/`,
  SHEETS_CHECK_FOR_TOKEN: `${ROUTES.PREDICT}/external-sheets/check-for-token/`,
  SHEETS_AUTH_URL: `${ROUTES.PREDICT}/external-sheets/get-auth-url/`,
  SHEETS_EXPORT_FORECAST: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/external-sheets/export/`,
  FORECAST_EXCEL_EXPORT: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/excel-export/`,
  SHEETS_IMPORT_CREATE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/external-sheets/create-import-sheet/`,
  SHEETS_IMPORT_DELETE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/external-sheets/delete-import-sheet/`,
  SHEETS_IMPORT_INFO: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/external-sheets/sheet-info/`,
  SHEETS_IMPORT_TEMPLATE_STATUS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/external-sheets/template-status/`,
  SHEETS_IMPORT_PREDICTIONS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/external-sheets/import/`,
  PERFORMANCE_MERTICS_CASHFLOW: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/actuals/performance-metrics/cashflow/`,
  BUSINESS_INSIGHTS_METRICS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.PERFORMANCE_METRICS}${ROUTES.BUSINESS_INSIGHTS}/`,
  PERFORMANCE_MERTICS_PROFIT_AND_LOSS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/actuals/performance-metrics/profit-and-loss/`,
  PERFORMANCE_MERTICS_BALANCE_SHEET: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/actuals/performance-metrics/balance-sheet/`,
  CUSTOMERS_AND_SUPPLIERS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.CONTACTS}/`,
  CUSTOMERS_AND_SUPPLIERS_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.CONTACTS}${ROUTES.CONTACT_BY_ID}/`,
  AVAILABLE_LINE_DATA_REPORTING_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/available-line-data/reporting/v2/`,
  AVAILABLE_LINE_DATA_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/available-line-data/reporting/`,
  AVAILABLE_LINE_DATA_TEMPLATES_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/available-line-data/report-templates/v2/`,
  AVAILABLE_LINE_DATA_TEMPLATE_FORMULA_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/available-line-data/template-formulas/v2/`,
  AVAILABLE_LINE_DATA_TEMPLATES_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/available-line-data/report-templates/`,
  AVAILABLE_LINE_DATA_TEMPLATE_FORMULA_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/available-line-data/template-formulas/`,
  AVAILABLE_ROW_FORMULA_DATA_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}/row-formulas/v2/`,
  AVAILABLE_ROW_FORMULA_DATA_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}/row-formulas/`,
  COLUMN_CALCULATIONS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}/financial-data/column-calculations/`,
  COLUMN_CALCULATIONS_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}/financial-data/column-calculations/`,
  ROW_FORMULA_DATA_BY_ID_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}/row-formulas/v2/:${ROUTE_PARAMS.ROW_FORMULA_ID}/`,
  ROW_FORMULA_DATA_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}/row-formulas/:${ROUTE_PARAMS.ROW_FORMULA_ID}/`,
  AVAILABLE_TEMPLATE_FORMULA_DATA_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}/template-formulas/v2/`,
  TEMPLATE_FORMULA_DATA_BY_ID_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}/template-formulas/v2/:${ROUTE_PARAMS.ROW_FORMULA_ID}/`,
  AVAILABLE_TEMPLATE_FORMULA_DATA_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}/template-formulas/`,
  TEMPLATE_FORMULA_DATA_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}/template-formulas/:${ROUTE_PARAMS.ROW_FORMULA_ID}/`,
  LIVE_REPORTS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/live-reports/`,
  LIVE_REPORTS_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/live-reports/`,
  LIVE_REPORT_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/live-reports/:${ROUTE_PARAMS.REPORT_ID}/`,
  LIVE_REPORT_AVAILABLE_DATASOURCES: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/live-reports/:${ROUTE_PARAMS.REPORT_ID}/available-datasources/`,
  LIVE_REPORT_AVAILABLE_DATASOURCES_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/live-reports/:${ROUTE_PARAMS.REPORT_ID}/available-datasources/`,
  LIVE_REPORT_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/live-reports/:${ROUTE_PARAMS.REPORT_ID}/`,
  LIVE_REPORTS_DUPLICATE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/live-reports/:${ROUTE_PARAMS.REPORT_ID}/duplicate/`,
  LIVE_REPORTS_DUPLICATE_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/live-reports/:${ROUTE_PARAMS.REPORT_ID}/duplicate/`,
  LIVE_REPORTS_FINANCIAL_DATA_V2: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/financial-data/v2/`,
  LIVE_REPORTS_FINANCIAL_DATA_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/financial-data/`,
  REPORT_TEMPLATES: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/templates/`,
  REPORT_TEMPLATE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/templates/:${ROUTE_PARAMS.TEMPLATE_ID}/`,
  REPORT_TEMPLATE_DUPLICATE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/templates/:${ROUTE_PARAMS.TEMPLATE_ID}/duplicate/`,
  REPORT_TEMPLATES_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/templates/`,
  REPORT_TEMPLATE_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/templates/:${ROUTE_PARAMS.TEMPLATE_ID}/`,
  REPORT_TEMPLATE_DUPLICATE_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/reporting/templates/:${ROUTE_PARAMS.TEMPLATE_ID}/duplicate/`,
  ACCOUNTS_PREVIEW_IMPACTS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}/assumptions/preview-impacts/`,
  REPORT_SCHEDULE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.REPORT_SCHEDULE}/`,
  REPORT_SCHEDULE_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.REPORT_SCHEDULE}/`,
  BUSINESS_INSIGHTS_SCHEDULE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.SCHEDULES}${ROUTES.BUSINESS_INSIGHT}/`,
  BUSINESS_INSIGHTS_SCHEDULE_REMOVE_ALL: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.SCHEDULES}${ROUTES.BUSINESS_INSIGHT}${ROUTES.REMOVE_ALL_SCHEDULES}/`,
  BUSINESS_INSIGHTS_SCHEDULE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.SCHEDULES}${ROUTES.BUSINESS_INSIGHT}/:${ROUTE_PARAMS.INSIGHTS_SCHEDULE_ID}/`,
  REPORT_DISPATCHED: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/`,
  REPORT_DISPATCHED_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/`,
  REPORT_EXPORTED: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.EXPORTED}/`,
  REPORT_EXPORTED_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.EXPORTED}/`,
  REPORT_EXPORTED_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.EXPORTED}/:${ROUTE_PARAMS.EXPORTED_REPORT_ID}/`,
  REPORT_EXPORTED_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.EXPORTED}/:${ROUTE_PARAMS.EXPORTED_REPORT_ID}/`,
  EMAIL_EXPORTED_REPORT: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.EXPORTED}/:${ROUTE_PARAMS.EXPORTED_REPORT_ID}${ROUTES.EMAIL}/`,
  EMAIL_EXPORTED_REPORT_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.EXPORTED}/:${ROUTE_PARAMS.EXPORTED_REPORT_ID}${ROUTES.EMAIL}/`,
  APPROVE_REPORT_DISPATCHED: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/:${ROUTE_PARAMS.DISPATCHED_REPORT_ID}/approve/`,
  APPROVE_REPORT_DISPATCHED_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/:${ROUTE_PARAMS.DISPATCHED_REPORT_ID}/approve/`,
  DENY_REPORT_DISPATCHED: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/:${ROUTE_PARAMS.DISPATCHED_REPORT_ID}/deny/`,
  DENY_REPORT_DISPATCHED_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/:${ROUTE_PARAMS.DISPATCHED_REPORT_ID}/deny/`,
  REPORT_DISPATCHED_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/:${ROUTE_PARAMS.DISPATCHED_REPORT_ID}/`,
  REPORT_DISPATCHED_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.DISPATCHED}/:${ROUTE_PARAMS.DISPATCHED_REPORT_ID}/`,
  REPORT_SCHEDULE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.REPORTING}${ROUTES.REPORT_SCHEDULE}/:${ROUTE_PARAMS.SCHEDULE_REPORT_ID}/`,
  REPORT_SCHEDULE_BY_ID_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}${ROUTES.REPORTING}${ROUTES.REPORT_SCHEDULE}/:${ROUTE_PARAMS.SCHEDULE_REPORT_ID}/`,
  NON_FINANCIAL_DRIVER_DATA: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-data/`,
  NON_FINANCIAL_DRIVER_NODE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-node/`,
  NON_FINANCIAL_DRIVER_NODE_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-node/:${ROUTE_PARAMS.DRIVER_NODE_ID}/`,
  NON_FINANCIAL_DRIVER_GROUP: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-group/`,
  NON_FINANCIAL_DRIVER_GROUP_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-group/:${ROUTE_PARAMS.DRIVER_NODE_ID}/`,
  FORMULA_NON_FINANCIAL_DRIVER: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/formula-driver/`,
  FORMULA_NON_FINANCIAL_DRIVER_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/formula-driver/:${ROUTE_PARAMS.DRIVER_NODE_ID}/`,
  FORMULA_NON_FINANCIAL_DRIVER_OPTIONS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/available-line-data/formula-drivers/`,
  FREESTYLE_NON_FINANCIAL_DRIVER: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/freestyle-driver/`,
  FREESTYLE_NON_FINANCIAL_DRIVER_BY_ID: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/freestyle-driver/:${ROUTE_PARAMS.DRIVER_NODE_ID}/`,
  DUPLICATE_NON_FINANCIAL_DRIVER: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-node/:${ROUTE_PARAMS.DRIVER_NODE_ID}/duplicate/`,
  REORDER_NON_FINANCIAL_DRIVER: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/driver-node/reorder/`,
  IMAGES: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/images/`,
  IMAGES_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/images/`,
  IMAGE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/images/:${ROUTE_PARAMS.IMAGE_ID}/`,
  IMAGE_CONSOLIDATION: `${WORKSPACES_AND_CONSOLIDATION_BASE}/images/:${ROUTE_PARAMS.IMAGE_ID}/`,
  PERFORMANCE_DASHBOARDS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/performance-dashboards/`,
  PERFORMANCE_DASHBOARD: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/reporting/performance-dashboards/:${ROUTE_PARAMS.DASHBOARD_ID}/`,
  ADVISOR_LOGIN: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.ADVISOR}${ROUTES.LOGIN}/`,
  ADVISOR_SCENARIOS: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.ADVISOR}${ROUTES.SCENARIOS}/`,
  ADVISOR_SCENARIOS_IMPORT: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}${ROUTES.FORECASTS}${ROUTES.FORECAST_BY_ID}${ROUTES.ADVISOR}${ROUTES.SCENARIOS}${ROUTES.IMPORT}/`,
  EXCEL_FORECAST_FILE_VALIDATION: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/excel-forecast-file-validation/:${ROUTE_PARAMS.EXCEL_ID}/`,
  EXCEL_DRIVER_FILE_VALIDATION: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/excel-driver-file-validation/:${ROUTE_PARAMS.EXCEL_ID}/`,
  EXCEL_FORECAST_UPLOAD: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/upload-forecast/:${ROUTE_PARAMS.EXCEL_ID}/`,
  EXCEL_DRIVER_UPLOAD: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/upload-driver/:${ROUTE_PARAMS.EXCEL_ID}/`,
  GENERATE_FORECAST_TEMPLATE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/generate-forecast-template/`,
  GENERATE_DRIVER_TEMPLATE: `${WORKSPACES_AND_ORGANISATION_BASE}${ROUTES.PREDICT}/excel-uploads/generate-driver-template/`
};

export const ACCOUNTING_TAG = 'accounting';

export const PREDICT_PRODUCT_SLUG = 'predict';

export enum DATASOURCES_STATUS {
  connect_failure = 'connect_failure',
  connect_start = 'connect_start',
  connect_redirect = 'connect_redirect',
  connect_success = 'connect_success',
  connect_timeout = 'connect_timeout',
  delete_failure = 'delete_failure',
  delete_start = 'delete_start',
  delete_success = 'delete_success',
  disconnect_failure = 'disconnect_failure',
  disconnect_start = 'disconnect_start',
  disconnect_success = 'disconnect_success',
  never_connected = 'never_connected',
  sync_failure = 'sync_failure',
  sync_initial_failure = 'sync_initial_failure',
  sync_initial_start = 'sync_initial_start',
  sync_start = 'sync_start',
  sync_success = 'sync_success',
  sync_initial_success = 'sync_initial_success',
  sync_update_status = 'sync_update_status',
  sync_initial_update_status = 'sync_initial_update_status',
  pending_setup = 'pending_setup'
}

export const ROLE_PERMISSIONS_CATEGORY = {
  SUPER_PERMISSION: 'Super permission',
  GENERAL_PERMISSION: 'General Permissions'
};

export const INTERCOM_LAUNCHER_ID = 'intercomLauncher';

/** KEYBOARD KEYS */
export const KEYBOARD_KEYS = {
  shift: 'Shift',
  tab: 'Tab',
  keydown: 'keydown'
};

export const FUTRLI_MARKETING_SITE_URL = 'https://www.futrli.com/';
